/**
 * Handles /join/{token} and /magic/{token}. The link in the email is a GET so
 * mail clients can prefetch it harmlessly; consuming the token needs this POST.
 */

import { apiPost, ApiError } from '../js/api.js'

const COPY = {
  join: {
    pending: 'Otvaramo tvoj retreat…',
    heading: 'Pozivnica',
  },
  magic: {
    pending: 'Prijavljujemo te…',
    heading: 'Prijava',
  },
}

export function renderTokenEntry(root, { kind, token, onSignedIn, onFailed }) {
  const copy = COPY[kind]

  root.innerHTML = `
    <h1 class="hero-title">Differ LX</h1>
    <section class="card">
      <p class="card__label">${copy.heading}</p>
      <p class="lede">${copy.pending}</p>
    </section>
  `

  const endpoint = kind === 'join' ? '/auth/join' : '/auth/magic'

  apiPost(endpoint, { token })
    .then((result) => {
      // Drop the token from the URL so it is not in history or the back button.
      window.history.replaceState({}, '', '/')
      onSignedIn(result)
    })
    .catch((error) => {
      const message = error instanceof ApiError ? error.message : 'Link nije valjan.'
      window.history.replaceState({}, '', '/')
      onFailed(message)
    })
}
